<template>
  <!-- 中信项目-兑换码页面定制 同步 T1006282 兑换链接 -->
  <div>
    <div id="loginbox">
      <img src="@/assets/img/citicSync/ypost.png" />
      <van-form class="lform" ref="form" @submit="subSuccess">
        <van-field
          class="lform-input key"
          placeholder="请输入订单详情中的卡密(或密码)"
          v-model="form.redeCodeNo"
          @blur="getInfo()"
          :rules="[
            {
              required: true,
              message: '请输入订单中的密码'
            }
          ]"
        />
        <van-field
          class="lform-input phone"
          placeholder="请输入您本人手机号码"
          v-model="form.phone"
          name="phone"
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          class="lform-input yzm"
          placeholder="请输入验证码"
          v-model="form.code"
          :maxlength="6"
          :rules="[
            {
              required: true,
              message: '请输入验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="sendCode">发送验证码</div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button
          class="submit"
          :loading="loading"
          loading-text="兑换中..."
          native-type="submit"
        >
          前往兑换
        </van-button>
      </van-form>
      <div class="prompt">
        <div class="prompt-title">
          <img src="@/assets/img/citicSync/ytips.png" alt="" />
          <span class="text">兑换说明</span>
        </div>
        <div class="content">
          <p>
            1、接收验证码的手机号请填写您本人手机号，兑换前请确保页面所有信息填写正确，兑换后不支持退款！
          </p>
          <p>
            2、如遇订单量大或网络拥堵，券码出库可能会有所延迟，建议您耐心等待若有疑问可咨询店铺在线客服。
          </p>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showDialog">
      <div class="center">
        <img src="@/assets/img/citicSync/warm.png" />
        <h1>温馨提示</h1>
        <div>
          该兑换码已兑换，若需要查看已兑换的券码，请输入
          <span>首次兑换时的手机号码</span>
        </div>
        <button @click="showDialog = false">好的</button>
      </div>
    </div>
  </div>
</template>

<script>
import { citicExchange, citicSendCode, citicGetPhone } from '@/api/citicSync.js'
export default {
  data() {
    return {
      time: 0,
      loading: false,
      showDialog: false,
      form: {
        redeCodeNo: undefined,
        phone: null,
        code: null
      }
    }
  },
  mounted() {
    this.$dialog.alert({
      title: '温馨提示',
      confirmButtonColor: '#c69528',
      message:
        '您即将跳转权益兑换页面，页面服务由易点生活电子商务有限公司提供。'
    })
  },
  methods: {
    async subSuccess() {
      try {
        this.loading = true
        const { code, data, message } = await citicExchange({
          ...this.form,
          redeemCodePageType: 3,
          pageTypeMatchFlag: false
        })
        this.loading = false
        switch (code) {
          case 0:
            this.$router.push({
              path: '/citicSyncList',
              query: { ...data, type: this.$route.query.type }
            })
            break
          case 1:
            this.showDialog = true
            break
          case 2:
            this.$router.push({
              path: '/citicSyncOutStock'
            })
            break
          case 3:
            this.$router.push({
              path: '/citicSyncCrowded'
            })
            break
          default:
            this.$toast.fail({
              message: message
            })
            break
        }
      } catch (error) {
        this.loading = false
      }
    },
    sendCode() {
      this.$refs.form.validate('phone').then(async () => {
        const { code, message } = await citicSendCode({
          ...this.form,
          domain: window.location.hostname
        })
        if (code === 0) {
          this.time = 60000
        } else {
          this.$toast.fail({
            message: message
          })
        }
      })
    },
    // 二次进入界面获取手机号
    async getInfo() {
      const { code, data } = await citicGetPhone({
        code: this.form.redeCodeNo
      })
      if (code === 0 && data) {
        this.form.phone = data
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../citicSync/ycitiSync.less';
</style>
